// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type CreateWizardInvoiceResponseFragment = { __typename?: 'CreateWizardInvoiceResponseDTO', invoiceId: number, bolloRequired: boolean };

export const CreateWizardInvoiceResponseFragment = gql`
    fragment CreateWizardInvoiceResponse on CreateWizardInvoiceResponseDTO {
  invoiceId
  bolloRequired
}
    `;
/* eslint-enable */